const CATEGORIES_DATA_REQUEST = 'CATEGORIES_DATA_REQUEST';
const CATEGORIES_DATA_SUCCESS = 'CATEGORIES_DATA_SUCCESS';
const CATEGORIES_DATA_FAILURE = 'CATEGORIES_DATA_FAILURE';

const initialState = {
  loading: false,
  success: false,
  failure: false,
  data: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CATEGORIES_DATA_REQUEST:
      return {
        loading: true,
        success: false,
        failure: false,
        data: null,
      };
    case CATEGORIES_DATA_SUCCESS:
      return {
        loading: false,
        success: true,
        failure: false,
        data: action.payload,
      };
    case CATEGORIES_DATA_FAILURE:
      return {
        loading: false,
        success: false,
        failure: true,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;

/**
 * Actions
 */

export const categoriesDataRequest = () => ({
  type: CATEGORIES_DATA_REQUEST,
});

export const categoriesDataSuccess = (payload) => ({
  type: CATEGORIES_DATA_SUCCESS,
  payload,
});

export const categoriesDataFailure = (payload) => ({
  type: CATEGORIES_DATA_FAILURE,
  payload,
});
